// Copyright (c) 2018 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {translate} from '../../../services/translation-service';

export const sortDirectionOptions = () => [
    new KeyValuePair({
        key: 'A',
        value: translate('ASCENDING')
    }),
    new KeyValuePair({
        key: 'D',
        value: translate('DESCENDING')
    })
];



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/services/sort-direction-options.js